import React from 'react';
import { Text, Block, Tooltip } from '@upsales/components';
import Bem from '@upsales/components/Utils/bemClass';
import translate from 'Components/Helpers/translate';
import './ExistInUpsales.scss';
import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';
import StateRouter from 'App/services/StateRouter';

type Client = {
	id: number;
	active: boolean;
};

type Props = { client: Client } & React.ComponentProps<typeof Block>;

const ExistInUpsales = ({ client, ...blockProps }: Props) => {
	const classes = new Bem('ExistInUpsales');
	const onClick = () => StateRouter.go('account.dashboard', { id: client.id });
	const hasInactiveAccounts = isAvailable(Feature.INACTIVE_COMPANIES);
	const inactive = hasInactiveAccounts && client.active === false;
	const tooltip = inactive ? 'account.alreadyExistingButInactive' : 'prospecting.allReadyInUpsales';

	return (
		<Tooltip title={translate(tooltip)} position="left" distance={20}>
			<Block
				className={classes.b()}
				backgroundColor={inactive ? 'grey-5' : 'super-light-green'}
				onClick={onClick}
				{...blockProps}
			>
				<Text color={inactive ? 'grey-10' : 'green'}>{translate('prospecting.inUpsales')}</Text>
			</Block>
		</Tooltip>
	);
};

export default ExistInUpsales;
